import { useEffect, useRef, useState } from "react";

export const useReveal = (options = {}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px", ...options }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [options]);

  return [ref, visible];
};

const Reveal = ({ children, className = "", as: Tag = "div", stagger = false }) => {
  const [ref, visible] = useReveal();
  const base = stagger ? "stagger" : "reveal";
  return (
    <Tag ref={ref} className={`${base} ${visible ? "is-visible" : ""} ${className}`}>
      {children}
    </Tag>
  );
};

export default Reveal;
